
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 18c-.552 0-1.005-.449-.952-.999.464-4.784 4.224-8.59 8.953-9.064.55-.056.999.398.999.95V18H1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10 18c0-5.245 3.947-9.557 9.001-10.063.55-.056.999.398.999.95V16a2 2 0 01-2 2h-8zM10 4.868c0 1.584-1.27 2.868-2.836 2.868-1.566 0-2.836-1.284-2.836-2.868C4.328 3.284 5.598 2 7.164 2 8.73 2 10 3.284 10 4.868zM20 4.868c0 1.584-1.27 2.868-2.836 2.868-1.566 0-2.836-1.284-2.836-2.868 0-1.584 1.27-2.868 2.836-2.868C18.73 2 20 3.284 20 4.868z","fill":"currentColor"}})])
          )
        }
      }
    